import { ref } from 'vue';

/**
 * Composable to track PWA update availability across components
 * Provides a persistent update state that can be shown in UI (drawer, FAB, etc.)
 */
const updateAvailable = ref(false);
const registration = ref<ServiceWorkerRegistration | null>(null);

export function usePWAUpdate() {
  function setUpdateAvailable(reg: ServiceWorkerRegistration | null = null) {
    updateAvailable.value = true;
    registration.value = reg;
  }

  function clearUpdate() {
    updateAvailable.value = false;
    registration.value = null;
  }

  function reloadApp() {
    const waiting = registration.value?.waiting;

    // The service worker deliberately does NOT call skipWaiting() on its own,
    // so the waiting worker only takes over once the user asks for it here.
    // Promoting it fires `controllerchange` in register-sw.ts, which performs
    // the reload; the direct reload below is the fallback for when there is no
    // waiting worker (e.g. the update already activated).
    if (waiting) {
      waiting.postMessage({ type: 'SKIP_WAITING' });
      return;
    }

    window.location.reload();
  }

  return {
    updateAvailable,
    registration,
    setUpdateAvailable,
    clearUpdate,
    reloadApp,
  };
}
